module.exports = __webpack_public_path__ + "media/landing/slider-5-880fc069.jpeg";